{
  "YOUR_FEEDBACK_SUGGESTION_HELP_IMPROVE_PRODUCT": "Umpan balik dan saran Anda akan membantu kami meningkatkan produk dan layanan kami.",
  "TECHNICAL_ISSUES_CONTACT_ADMIN_OR_SP": "Jika Anda memiliki masalah teknis atau dukungan, atau memerlukan bantuan segera, harap hubungi Administrator Laserfiche Anda atau Penyedia Solusi seperti yang tercantum dalam perjanjian layanan Anda.",
  "FOUND_SOMETHING_LIKE_DISLIKE_LET_US_KNOW": "Menemukan sesuatu yang Anda suka atau tidak suka? Beri tahu kami tentang hal itu.",
  "DO_YOU_HAVE_IDEA_NEW_FEATURE_IMPROVEMENT_LOOK_FORWARD_TO_HEARING": "Apakah Anda memiliki ide untuk fitur baru atau perbaikan? Kami menantikan untuk mendengarnya.",
  "PLEASE_DO_NOT_INCLUDE_CONFIDENTIAL_OR_PERSONAL_INFO_IN_FEEDBACK": "Harap jangan sertakan informasi rahasia atau pribadi dalam umpan balik Anda",
  "TELL_US_ABOUT_EXPERIENCE": "Ceritakan kepada kami tentang pengalaman Anda",
  "TELL_US_ABOUT_IDEA": "Ceritakan kepada kami tentang ide Anda",
  "I_HAVE_FEEDBACK": "Saya memiliki umpan balik",
  "I_HAVE_SUGGESTION": "Saya memiliki saran",
  "YOU_MAY_CONTACT_ME_ABOUT_FEEDBACK": "Anda dapat menghubungi saya mengenai umpan balik ini",
  "IF_YOUD_LIKE_TO_JOIN_OUR_CUSTOMER_PANEL": "Jika Anda ingin bergabung dengan Panel Pelanggan kami,",
  "PLEASE_CLICK_HERE": "silakan klik di sini.",
  "IMAGE_EXCEEDS_MAX_FILE_SIZE_0": "Gambar melebihi ukuran file maksimum sebesar {0}.",
  "IMAGE_CORRUPTED_UNRECOGNIZED_FORMAT": "Gambar rusak atau dalam format yang tidak dikenali.",
  "ACCEPTED_FORMATS_ARE_0": "Format yang diterima adalah: {0}.",
  "IMAGE_NOT_ATTACHED": "Gambar tidak dilampirkan.",
  "ATTACH_IMAGE": "Lampirkan Gambar",
  "PLEASE_ATTACH_ONLY_ONE_IMAGE": "Harap lampirkan hanya satu gambar.",
  "TAGS": "Tag",
  "ADD_TAGS": "Tambahkan tag",
  "ADD_MORE_TAGS": "Tambahkan tag lainnya",
  "NO_TAGS_AVAILABLE": "Tidak ada tag yang tersedia"
}
